module.exports = __webpack_public_path__ + "static/media/stepsTable.c61e21cf.png";